export default __webpack_public_path__ + "static/media/boxRed.d60a9d54.png";